import { gql } from "@apollo/client";

export const GET_PAYMENTGATEWAYS = gql`
  query getPaymentGateways {
    getPaymentGateways {
      name
      description
      paymentid
      img
      path
    }
  }
`;

export const GET_DISTPAYMENTGATEWAYS = gql`
  query getDistPaymentGateways(
    $packageid: String
    $referralcode: String!
    $price: Float!
  ) {
    getDistPaymentGateways(
      packageid: $packageid
      referralcode: $referralcode
      price: $price
    ) {
      status
      error
      paymentgateways {
        name
        description
        paymentid
        img
        path
      }
      customer {
        firstname
        lastname
        address1
        address2
        city
        state
        zip
        phone
        email
        createdate
        ipaddress
      }
    }
  }
`;
